<template>
  <v-dialog
  persistent
  v-model="showDialog"
  max-width="400px"
  :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-btn color="accent" depressed large fab slot="activator">
      <v-icon dark>add</v-icon>
    </v-btn>
    <v-card :class="{'no-border': $vuetify.breakpoint.xsOnly}">
      <v-container class="modal-pad">
        <v-layout row align-center wrap mb-3>
          <v-flex xs10 style="height:30px;">
            <span class="subheading">Add a repeat job</span>
          </v-flex>
          <v-flex xs2 class="text-xs-right">
            <v-btn fab flat medium @click="showDialog = false">
              <v-icon >close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout row v-if="error">
          <v-flex xs12 sm6 offset-sm3>
            <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
          </v-flex>
        </v-layout>
        <form @submit.prevent="onCreateRepeatJob">
        <v-layout column pt-2>
          <v-flex >
              <v-combobox
                v-model="client_nameFormatted"
                label="Client"
                :items="clients"
                item-text="name"
                item-value="name"
                hide-details
                dense
                placeholder="Choose or add a client"
                @input="saveClientName()"
                :autofocus="!$vuetify.breakpoint.xsOnly"
                ref="clientname"
              ></v-combobox>
              <line-items
                :lineItems="lineItems"
                :newLineItemKey="newLineItemKey"
                :itemAmount="amount"
                :itemTotalTaxPortion="totalTaxPortion"
                :itemTotalNetAmount="totalNetAmount"
                :itemTitle="title"
                :itemTaxIncluded="taxIncluded"
                @create-new-key="getLineItemKey"
                @line-items-output="updateJobFromLineItems"
              />
              <v-radio-group v-model="schedule.frequency" class="pt-0 mt-3">
                <v-radio color="primary" label="Monthly" value="monthly"></v-radio>
                <v-radio color="primary" label="Yearly" value="yearly"></v-radio>
              </v-radio-group>
              <v-select
              v-model="schedule.dayOfMonth"
              label="on day of month"
              :items="dayRange"
              dense
              ></v-select>
              <transition name="fade">
                <v-select
                v-show="schedule.frequency === 'yearly'"
                v-model="schedule.monthOfYear"
                label="Month of year"
                :items="monthRange"
                item-text="month"
                item-value="number"
                dense
                >
                </v-select>
              </transition>
          </v-flex>
        </v-layout>
        <v-layout pt-0 align-end justify-start row fill-height>
          <v-btn style="margin-left:0; margin-right:0;" color="primary" large depressed type="submit" :disabled="loading" :loading="loading">
              Add Repeat Job
              <span slot="loader" class="custom-loader">
                <v-icon light>cached</v-icon>
              </span>
            </v-btn>
        </v-layout>
        </form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatDate } from '@/components/Mixins/formatDate'
import firebase from 'firebase/app'
import 'firebase/database'
import { calculateRepeatDateFromSchedule } from '@/components/Mixins/calculateRepeatDateFromSchedule'
import LineItems from '@/components/Shared/LineItems'

export default {
  name: 'CreateRepeatJobModal',
  mixins: [
    calculateRepeatDateFromSchedule,
    formatDate
  ],
  components: {
    LineItems
  },
  data () {
    return {
      showDialog: false,
      jobref: '',
      lineItemRef: '',
      title: 'Untitled Job',
      clientName: '',
      amount: '0.00',
      totalTaxPortion: 0,
      totalNetAmount: 0,
      taxIncluded: this.$store.getters.group.taxCalcInclusive,
      lineItems: {},
      schedule: {
        frequency: 'monthly',
        dayOfMonth: new Date().getDate(),
        monthOfYear: new Date().getMonth(),
        lastCreated: 'never'
      },
      nextRepeats: '',
      zuluRepeats: '',
      client_nameFormatted: '',
      clients: this.$store.getters.clients,
      grouptz: this.$store.getters.group.tz,
      dayRange: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
      monthRange: [
        { month: 'January', number: 0 },
        { month: 'February', number: 1 },
        { month: 'March', number: 2 },
        { month: 'April', number: 3 },
        { month: 'May', number: 4 },
        { month: 'June', number: 5 },
        { month: 'July', number: 6 },
        { month: 'August', number: 7 },
        { month: 'September', number: 8 },
        { month: 'October', number: 9 },
        { month: 'November', number: 10 },
        { month: 'December', number: 11 }
      ],
      currSymbol: this.$store.getters.group.currSymbol,
      newLineItemKey: ''
    }
  },
  watch: {
    async showDialog (val) {
      if (!val) return
      requestAnimationFrame(() => {
        this.$refs.clientname.focus()
      })
      this.jobref = await firebase.database().ref(`lists/${this.$store.getters.user.group}/list3`).push().key
      this.getLineItemKeyInitial()
      this.getLineItemKey()
      this.lineItems = {
        [this.lineItemRef]: {
          amount: '0.00',
          creatorId: this.$store.getters.user.id,
          description: 'Untitled Job',
          id: this.lineItemRef,
          lineTotal: '0.00',
          taxPortion: '0.00',
          taxRate: this.$store.getters.group.taxRate
        }
      }
    }
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    user () {
      return this.$store.getters.user
    }
  },
  methods: {
    updateJobFromLineItems (payload) {
      // update the repeat job with the lineitems output
      this.amount = payload.amount
      this.totalTaxPortion = payload.totalTaxPortion
      this.totalNetAmount = payload.totalNetAmount
      this.title = payload.title
      this.taxIncluded = payload.taxIncluded
      this.lineItems = payload.lineItems
    },
    getLineItemKeyInitial () {
      const listId = 3
      const jobId = this.jobref
      const groupId = this.user.group
      const ref = firebase.database().ref('lists/' + groupId + '/list' + listId + '/' + jobId + '/lineItems').push().key
      this.lineItemRef = ref
    },
    getLineItemKey () {
      const listId = 3
      const jobId = this.jobref
      const groupId = this.user.group
      const ref = firebase.database().ref('lists/' + groupId + '/list' + listId + '/' + jobId + '/lineItems').push().key
      this.newLineItemKey = ref
    },
    onCreateRepeatJob () {
      this.$refs.clientname.blur()
      this.$nextTick(() => {
        this.$store.dispatch('clearError')
        if (this.clientName === '' || this.clientName === null) {
          this.$store.commit('setError', { message: 'Please enter a name for the client' })
          return
        }
        const newSchedule = {
          frequency: this.schedule.frequency,
          dayOfMonth: this.schedule.dayOfMonth,
          monthOfYear: this.schedule.monthOfYear,
          lastCreated: this.schedule.lastCreated,
          tz: this.grouptz
        }
        const repeatTime = this.calculateRepeatDateFromSchedule(newSchedule)
        const newJob = {
          title: this.title,
          clientName: this.clientName,
          amount: this.amount,
          totalTaxPortion: this.totalTaxPortion,
          totalNetAmount: this.totalNetAmount,
          taxIncluded: this.taxIncluded,
          lineItems: this.lineItems,
          schedule: newSchedule,
          // store this as a nice simple string for display only
          nextRepeats: this.formatDate(repeatTime),
          // store the actual zulu time (UTC +0.00) that the server be using
          // we'll use this with the cronjobs to work out exactly when to fire a new job off
          // eg. 25 Feb 19 in East Kazakhstan Time is "2019-02-24T18:00:00.000Z" ie 6 hours ahead
          // the cron run at 6pm on the 24th uk time will create this job at midnight kazakh time
          zuluRepeats: this.getUTCRepeatDateFromTimeZonedRepeatDate(repeatTime, this.grouptz)
        }
        // console.log('next job', newJob)
        this.$store.dispatch('addRepeatJob', newJob)
          .then(newRepeatJob => {
            this.$emit('pushData', newRepeatJob)
          })
          .then(() => {
            this.showDialog = false
            this.title = ''
            this.clientName = ''
            this.client_nameFormatted = ''
            this.amount = ''
            this.totalTaxPortion = 0.00
            this.totalNetAmount = 0.00
            this.title = 'Untitled Job'
            this.taxIncluded = this.$store.getters.group.taxCalcInclusive
            this.lineItems = {}
            this.schedule = {
              frequency: 'monthly',
              dayOfMonth: new Date().getDate(),
              monthOfYear: new Date().getMonth(),
              lastCreated: 'never'
            }
            this.nextRepeats = ''
          })
      })
    },
    saveClientName () {
      // save the client name which will either be an object from select or a typed in value
      // check we have something
      if (this.client_nameFormatted !== null && this.client_nameFormatted !== '') {
        // if it's a string...
        if (typeof this.client_nameFormatted === 'string') {
          // .. use the straight string variable and save the job
          this.clientName = this.client_nameFormatted
        } else {
          // else it's an object from the select so grab the name value from it
          this.clientName = this.client_nameFormatted.name
        }
      }
      const currentClientName = this.clientName
      if (this.clientName === '' || this.clientName === null) {
        return
      }
      if (this.clients.filter(function (client) { return client.name === currentClientName }).length > 0) {
      } else if (currentClientName !== '') {
        this.$store.dispatch('createClient', {
          name: this.clientName
        })
      }
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }

}
</script>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
